import { Component } from 'preact'
import Header from '../../header'
import Panel from '../../panel'
import AlertComponent from '../../ui-components/AlertComponent'
import InputGroup from '../../ui-components/InputGroup'
import Attachments from '../../category/control/Attachments'
import axios from 'axios'

class KnowledgeBaseParentCategoryAdd extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      errors: [],
      category: props.category,
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      successMessage: ''
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.setValue = this.setValue.bind(this)
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }

    this.setState({ isLoading: true })

    axios.post('/platform/knowledge-base/new', newData)
      .then((response) => {
        let redirectTo = `${this.props.editLink}?id=${response.data.id}&success=true`
        window.location.assign(redirectTo)
      })
      .catch(() => {
        this.setState({ messageType: 'error', isLoading: false })
      })
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })
  }

  render (props, state) {
    return (
      <div className='category-container category-add_container'>
        <Header
          title='Add parent category'
          cancelCallback={() => { window.location.assign(props.overviewLink) }}
          saveCallback={this.saveCategory}
          isLoading={this.state.isLoading}
        />
        <AlertComponent messageType={state.messageType} />
        <Panel title='Details'>
          <form>
            <InputGroup
              title='Title'
              placeholder='Add a title'
              type={'text'}
              error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
              onChange={(e) => this.setValue('title', e.target.value)}
              value={state.category.title} />
            <InputGroup
              title='Description'
              placeholder='Add a description'
              error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
              type={'text'}
              onChange={(e) => this.setValue('description', e.target.value)}
              value={state.category.description} />
            <Attachments
              label='Hero image'
              className='hero-image'
              meta={
                <div>
                  <div>Hero image will be shown on top of the category page.</div>
                  <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
                </div>
              }
              isAttachmentSelected={state.category.heroImage}
              imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
              width={2880}
              height={480}
              onUpdate={(data) => this.setValue('heroImage', data)}
            />
            <Attachments
              label='Category card image'
              className='thumbnail-image'
              meta={
                <div>
                  <div>Category card image will be shown on category cards on homepage.</div>
                  <div>Maximum file size: 5MB. Allowed image types: .jpg, .png. We recommend a minimum of 144*144px</div>
                </div>
              }
              isAttachmentSelected={state.category.thumbnailImage}
              imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
              width={144}
              height={144}
              onUpdate={(data) => this.setValue('thumbnailImage', data)}
            />
          </form>
        </Panel>
      </div>
    )
  }
}

export default KnowledgeBaseParentCategoryAdd
